import React from 'react';
import { useTheme } from '@mui/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

import Colors from '../../styles/colors';

const Footer = () => {
    const muiTheme = useTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('tablet'), { noSsr: true });
    return (
        <Container
            component="footer"
            style={{
                backgroundColor: Colors.darkPurple,
            }}
        >
            <Box
                sx={{
                    margin: '0 auto',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    minHeight: 74,
                    maxWidth: (theme) => theme.breakpoints.values.desktop,
                }}
            >
                <Grid item container mobile={12} tablet={11}>
                    <Grid
                        item
                        mobile={12}
                        tablet="auto"
                        sx={{
                            textAlign: isMobile ? 'center' : 'left',
                            pt: isMobile ? 3 : 0,
                        }}
                    >
                        <Typography
                            style={{
                                color: '#FFFFFF',
                                fontSize: '1.6rem',
                                fontFamily: 'Inter',
                                lineHeight: 'normal',
                            }}
                        >
                            {new Date().getFullYear()} &copy; Theory and Principle. All Rights Reserved.
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        mobile={12}
                        tablet="auto"
                        sx={{
                            textAlign: isMobile ? 'center' : 'left',
                            pt: isMobile ? 3 : 0,
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: '1.6rem',
                                fontFamily: 'Inter',
                                lineHeight: 'normal',
                            }}
                        >
                            <Link to="/privacy" style={{ color: '#FF0080', paddingLeft: 15 }}>Privacy Policy</Link>
                            <Link to="/security" style={{ color: '#FF0080', paddingLeft: 15 }}>Data Security</Link>
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default Footer;
